/**
 * A utility component that conditionally renders its children based on a boolean condition.
 * This provides a cleaner alternative to using ternary operators or && in JSX.
 * 
 * @example
 * // Instead of: {isVisible && <div>Content</div>}
 * // You can use:
 * <Show if={isVisible}>
 *   <div>Content</div>
 * </Show>
 * 
 * @param props.if - The boolean condition that determines if children should be rendered
 * @param props.children - The React elements to conditionally render
 * @returns The children if condition is true, null otherwise
 */
export function Show({children, "if": condition}: React.PropsWithChildren<Condition>): React.ReactNode | null {
	if (!condition || !children) {
		return null;
	}
	return children;
}

type Condition = { "if": boolean }